import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CpeInfoEditorComponent } from './cpe-info-editor.component';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { ComboComponentModule } from '@adaptiva/widgets/combo';

const _widgets = [
	AlertComponentModule,
	ComboComponentModule,
	ContainerComponentModule,
	InputComponentModule,
	LabelComponentModule,
];

@NgModule({
	imports: [
		_widgets,
		CommonModule
	],
	declarations: [
		CpeInfoEditorComponent
	],
	exports: [
		CpeInfoEditorComponent
	]
})
export class CpeInfoEditorComponentModule {

}
